import React, { useState, useEffect } from 'react';
import { LinkCheckerConfig } from '../repository/linkCheckerRepository';

interface ConfigFormProps {
  initialConfig?: LinkCheckerConfig;
  onSubmit: (website_url: string, description: string) => Promise<void>;
  onCancel: () => void;
  isLoading: boolean;
  error: string | null;
}

const ConfigForm: React.FC<ConfigFormProps> = ({
  initialConfig,
  onSubmit,
  onCancel,
  isLoading,
  error,
}) => {
  const [websiteUrl, setWebsiteUrl] = useState(initialConfig?.website_url || '');
  const [description, setDescription] = useState(initialConfig?.description || '');

  useEffect(() => {
    if (initialConfig) {
      setWebsiteUrl(initialConfig.website_url);
      setDescription(initialConfig.description);
    }
  }, [initialConfig]);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    await onSubmit(websiteUrl, description);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="field">
        <label className="field-label" htmlFor="websiteUrl">Website URL</label>
        <input
          className="input"
          type="url"
          id="websiteUrl"
          value={websiteUrl}
          onChange={(e) => setWebsiteUrl(e.target.value)}
          required
          disabled={isLoading}
        />
      </div>
      <div className="field">
        <label className="field-label" htmlFor="description">Description</label>
        <input
          className="input"
          type="text"
          id="description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          required
          disabled={isLoading}
        />
      </div>
      {error && <div className="alert error">{error}</div>}
      <div className="button-row">
        <button className="button" type="submit" disabled={isLoading}>
          {isLoading ? 'Saving...' : (initialConfig ? 'Update Configuration' : 'Add Configuration')}
        </button>
        <button className="button secondary" type="button" onClick={onCancel} disabled={isLoading}>
          Cancel
        </button>
      </div>
    </form>
  );
};

export default ConfigForm;
